import cache from 'memory-cache';

import type { SelectPropsBase } from '@ts-types/category-funnelling';

import { SelectScreen } from './screens/SelectScreen';
import type { APIFunnelJourney, JourneyType } from 'lib/sdks/strapi';
import { getFunnelJourney, getScreen } from 'lib/sdks/strapi';

const singleSelectScreen = ({
  id,
  title,
  description,
  component,
  shortName,
  storeData,
}: SelectPropsBase) => {
  return {
    component: SelectScreen,
    key: id,
    title,
    description,
    choices: component[0].items,
    showSubheading: component[0].showSubheading,
    showDescription: component[0].showDescription,
    shortName,
    storeData,
  };
};

const screenTypes = {
  'funneling.selection': singleSelectScreen,
} as const;

export const getScreenConfig = async (screenId: number) => {
  try {
    const screenResult = await getScreen(screenId);

    const parsedScreenResult =
      screenTypes[screenResult.component[0].__component](screenResult);

    return parsedScreenResult;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    return null;
  }
};

export const getFunnelConfig = async (
  categoryId: number,
  type: JourneyType,
): Promise<APIFunnelJourney | null> => {
  try {
    const cachedResponse = cache.get(`funnel${categoryId}_${type}`);

    if (cachedResponse) {
      return cachedResponse;
    }

    const categoryResults = await getFunnelJourney(categoryId, type);

    if (!categoryResults || categoryResults.length === 0) {
      return null;
    }

    cache.put(
      `funnel${categoryId}_${type}`,
      categoryResults[0],
      1 * 1000 * 60 * 60,
    );

    return categoryResults[0];
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    return null;
  }
};

export const FunnellingFlowStepIds = {
  POSTCODE: 100001,
  CLEARED: 100002,
};
